<template>
    <div class="bg-blue-100 flex items-center justify-center py-96">
        <div class="bg-white rounded-2xl shadow-lg p-48 max-w-md w-full mx-24">
            <div class="text-center">
                <h1 class="text-xl font-bold text-primary mb-24">
                    {{ $t('dashboard.customer_info_error') }}
                </h1>
                <button @click="retryLoadCustomerInfo" class="self-btn-primary mx-auto" :disabled="isRetrying">
                    <span>{{ $t('dashboard.retry') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import store from '@/store';

@Component
export default class CustomerInfoErrorView extends Vue {
    isRetrying = false;

    async retryLoadCustomerInfo(): Promise<void> {
        this.isRetrying = true;
        try {
            const success = await store.dispatch('authenticateUser');
            if (success) {
                // If authentication succeeds, redirect to dashboard
                this.$router.push({ name: 'Dashboard', params: { lang: this.$i18n.locale } });
            }
        } finally {
            this.isRetrying = false;
        }
    }
}
</script>

<style scoped></style>
